import * as Preact from "preact"
import Pointer from "poin"
import Joyp from "joyp"
import prettyms from "pretty-ms"

import App from "@fae/source/models/App.js"
import Dev from "@fae/source/models/dev/Dev.js"
import Navigation from "@fae/source/engine/navigating/Navigation.js"
import StageModel from "@fae/source/models/Stage.js"

import Stage from "@fae/source/views/Stage.jsx"
import UnitSprite from "@fae/source/views/components/UnitSprite.jsx"
// import ChapterUI from "@fae/source/views/ChapterUI.jsx"
// import Frame from "@fae/source/views/components/Frame.jsx"
// import Snow from "@fae/source/views/components/Snow.jsx"
// import ModalUI from "@fae/source/views/ModalUI.jsx"
// import PauseMenu from "@fae/source/views/components/PauseMenu.jsx"
// import TitleSplashScreen from "@fae/source/views/components/TitleSplashScreen.jsx"

// import Audiomix from "@fae/source/engine/Audiomix.js"
// import Testlaunch from "@fae/source/engine/testing/utility/Testlaunch.js"

import tests from "@fae/source/data/tests.js"
import test from "@fae/source/engine/testing/test.js"
import audios from "@fae/source/data/audios.js"
import savetests from "@fae/source/data/games/savetests.js"
import preload from "@fae/source/data/preload.js"
import games from "@fae/source/data/games"
import {getTodayDevTip} from "@fae/source/data/devtips.jsx"

import DevUiScreen from "@fae/source/views/dev/screens/DevUiScreen.jsx"
import "@fae/source/views/dev/screens/DevScreens.less"

export default {
    "DevHellScreen": function() {
        const testgroup = window.fae.test.results
        return (
            <div class="DevHellScreen">
                <title>Fae - Dev</title>
                <section>
                    <div class="Header">Faerie Fire <a class="Link" href="/#/dev/about">v0.29.1</a></div>
                    <a class="Button" href="https://github.com/ehgoodenough/faerie-fire/wiki" target="_blank">
                        <div class="Icon">
                            <span class="material-symbols-rounded">book_5</span>
                        </div>
                        <div class="Label">Engine Documentation</div>
                    </a>
                    <a class="Button" href="/#/dev/tests">
                        <div class="Icon">
                            <span class="material-symbols-rounded">science</span>
                        </div>
                        <div class="Label">Engine Tests</div>
                        {window.fae?.test?.results?.badcount > 0 ? (
                            <div class="Badge" color="red">{window.fae?.test?.results?.badcount} of {window.fae?.test?.results?.count}</div>
                        ) : (
                            <div class="Badge">{window.fae?.test?.results?.count}</div>
                        )}
                    </a>
                    <div class="Divider"/>
                    <a class="Button" href="/#/dev/scripts/import">
                        <div class="Label">Script Importer</div>
                    </a>
                    <a class="Button" href="/#/dev/qa">
                        <div class="Label">Quality Assurance</div>
                    </a>
                </section>
                <section>
                    {Object.values(games).map((game) => (
                        <a class="Button" size="big" href={"/#/games/" + game.key + "/title"}>
                            <div class="Label">
                                {game.title || "???"}
                            </div>
                            <div class="Badge">
                                {game.key || "???"}
                            </div>
                        </a>
                    ))}
                </section>
            </div>
        )
    },
    "DevTipScreen": function() {
        const devtip = getTodayDevTip()
        return (
            <div class="DevHellScreen">
                <title>Fae - Dev Tip</title>
                <section>
                    <div class="Header">Dev Tip: {devtip.label}</div>
                    <div class="Description">{devtip.description}</div>
                    <a class="Button" onClick={(event) => window.history.back()}>
                        <div class="Icon"><span class="material-symbols-rounded">arrow_back</span></div>
                        <div class="Label">Back</div>
                    </a>
                </section>
            </div>
        )
    },
    "DevQualityAssuranceScreen": function() {
        return (
            <div class="DevScreen">
                <title>Fae - QA</title>
                <page>
                    <div class="Link" onClick={() => Navigation.go("/dev/ui")}>Game UI</div>
                    <h2>Tests</h2>
                    <div>QA Sanity Checks</div>
                    <div>End-to-end Tests</div>
                    <div>Snapshot Integration Tests (skills!!)</div>
                    <div>Engine Bootup Benchmarks</div>
                    <div>Engine Runtime Benchmarks</div>
                    <div>Engine Unit Tests</div>
                    <h2>Assets</h2>
                    <div>Audio Mocks (build size)</div>
                    <div>Unit Sprite Mocks, Part Permutations, Palette Swaps, Turnarounds, Animations</div>
                    <div>Image Mocks (build size, spritesheet packing, unused assets, used but not preloaded assets)</div>
                    <div>Dialogue Mocks (every word, every locale, every font)</div>
                    <div>Skill Breakdown Mocks (every skill, does it fit, localization)</div>
                    <div>Item Mocks (in every context, from inventory to equipped to hovered as an action to dropped as loot)</div>
                    <div>UI Mocks (hud, chapter hud, modals, screens, components, ui animations, using stylesheet variables)</div>
                    <div>Stage Image Mocks?? Overworld Mocks??</div>
                </page>
            </div>
        )
    },
    "DevTestListScreen": function() {
        return (
            <div class="DevTestListScreen">
                <title>Fae - Dev - Tests</title>
                <div class="Header">
                    {test.results.badcount == 0 ? (
                        <span class="Passing">✅ {test.results.count} test{(test.results.count > 1 ? "s" : "")}</span>
                    ) : (
                        <span class="Failing">🔴 {test.results.badcount} out of {test.results.count} test{(test.results.count > 1 ? "s" : "")} failing</span>
                    )} - {prettyms(test.results.duration)}
                </div>
                <div class="TestSection">
                    <div class="Tests">
                        {tests.map((test) => {
                            return (
                                <div class="Test" status={test.status || "loading"}
                                    onClick={() => Navigation.go("/dev/tests/" + test.key)}>
                                    <div class="Slug">{test.key}</div>
                                    <div class="Description">
                                        {test.description && " - " + test.description}
                                    </div>
                                    <div class="Duration">
                                        {test.duration != undefined && prettyms(test.duration)}
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    <div class="Tests">
                        {Object.keys(savetests).map((key) => {
                            const test = savetests[key]
                            return (
                                <div class="SavestateTest" status={test.status || "loading"}
                                    isLoading={test.isLoading}
                                    onClick={() => Navigation.go("/dev/savetests/" + key)}>
                                    <div class="Name">
                                        {test.gameSlug} {test.chapterSlug} {test.memo || test.name}
                                    </div>
                                    <div class="Duration">
                                        {test.duration != undefined && prettyms(test.duration)}
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
                <div class="Buttons">
                    <div class="Button" onClick={() => {Dev.reloadTestFiles()}}>
                        Refresh Savetests List
                    </div>
                    <div class="Button" onClick={() => {Testlaunch.perform(tests)}}>
                        Run Savetests
                    </div>
                </div>
            </div>
        )
    },
    "DevTestScreen": function() {
        return (
            <div class="DevTestScreen" status={Navigation.state.test.status}>
                <title>Fae - Dev - Tests</title>
                <div class="TestSlug">{Navigation.state.test.key}</div>
                <div class="Message">{Navigation.state.test?.error?.message}</div>
            </div>
        )
    },
    "DevSavetestScreen": function() {
        return <DevSavetestScreen/>
    },
    "DevImportsScreen": function() {
        return (
            <div class="DevListScreen">
                <div class="Header">Imported Images</div>
                <div class="Unit">
                    <div class="Image Column"/>
                    <div class="Name Column">Name</div>
                    <div class="Number Column">HP</div>
                    <div class="Number Column">PW</div>
                    <div class="Number Column">MR</div>
                    <div class="Number Column">AR</div>
                    <div class="String Column">Type</div>
                    <div class="String Column">Element</div>
                </div>
                <div class="Units">
                    {Object.keys(preload.images).map((imageKey) => {
                        const image = preload.images[imageKey]
                        return (
                            <div class="Unit">
                                <div class="Image Column">
                                    <img src={image.element.src}/>
                                </div>
                                <div class="Image Column">
                                    <img src={image.palettes?.red}/>
                                </div>
                                <div class="Image Column">
                                    <img src={image.palettes?.blue}/>
                                </div>
                                <div class="Name Column">{imageKey}</div>
                            </div>
                        )
                    })}
                </div>
            </div>
        )
    },
    "DevScriptImporterScreen": function() {
        return <DevScriptImporterScreen/>
    },
    "DevUiListScreen": function() {
        return (
            <div class="DevUiListScreen">
                <title>Fae - Dev - UI</title>
                <div class="Header">Game Ui</div>
                <div class="UIs">
                    <a class="UI" href="#/dev/ui/Dialogue">Dialogue Modal</a>
                    <a class="UI" href="#/dev/ui/ChapterStart">Chapter Start Modal</a>
                    <a class="UI" href="#/dev/ui/PlayerTurnStart">Turn Start Modal - Player Phase</a>
                    <a class="UI" href="#/dev/ui/NonPlayerTurnStart">Turn Start Modal - Non-Player Phase</a>
                    <a class="UI" href="#/dev/ui/ChapterFailure">Chapter Failure Modal</a>
                    <a class="UI" href="#/dev/ui/ChapterSuccess">Chapter Success Modal</a>
                    <a class="UI" href="#/dev/ui/ChapterSuccessClassic">Chapter Success Modal - Obsolete</a>
                    <a class="UI" href="#/dev/ui/CharacterLevelUp">Character Levelup Modal</a>
                    <a class="UI" href="#/dev/ui/CharacterSplash">Character Recruitment Modal</a>
                    <a class="UI" href="#/title">Title Screen</a>
                    <a class="UI" href="#/">Title Screen - with Splash</a>
                    <a class="UI" href="#/options">Options Screen</a>
                    <a class="UI" href="#/credits">Credits Screen</a>
                    <a class="UI" href="#/dev/ui/Loading">Loading Screen</a>
                </div>
            </div>
        )
        // <div class="UI">Obsolete: Character Drafting</div>
        // <div class="UI">Obsolete: Declaration?</div>
        // <div class="UI">Combat HUD</div>
        // <div class="UI">Combat HUD, Hidden Unit Information</div>
        // <div class="UI">Combat HUD, Tutorial Popups</div>
        // <div class="UI">Pause Menu</div>
        // <div class="UI">Overworld - Unfolding Revealing</div>
        // <div class="UI">Pre-Combat Prepare</div>
    },
    "DevUiScreen": DevUiScreen,
}
